import { render } from "./EmbedDialog.vue?vue&type=template&id=36178701"
import script from "./EmbedDialog.vue?vue&type=script&lang=js"
export * from "./EmbedDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/EmbedDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36178701"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36178701', __exports__)) {
    api.reload('36178701', __exports__)
  }
  
  module.hot.accept("./EmbedDialog.vue?vue&type=template&id=36178701", () => {
    api.rerender('36178701', render)
  })

}


export default __exports__